import auction from "./auction";
import banners from "./banners";
import boards from "./boards";
import center from "./center";
import fairs from "./fairs";
import forms from "./forms";
import me from "./me";
import lawyers from "./lawyers";
import message from "./message";
import setting from "./setting";
import practice from "./practice";
import shop from "./shop";
import terms from "./terms";
import users from "./users";
import popups from "./popups";
import * as easyleg from "./easyleg";

export default {
    ...easyleg,
    auction,
    banners,
    boards,
    center,
    fairs,
    forms,
    me,
    lawyers,
    message,
    setting,
    practice,
    shop,
    terms,
    users,
    popups,
};
